import React from 'react';

import PropTypes from 'prop-types';
import Input from '@tds/core-input';

import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectWebformOrderId = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        Max_200_Characters: max200Characters,
        webformOrderID,
        placeHolderWebformOrderID
      }
    }
  } = locale === 'en-US' ? EN : FR;
  
  return (
    <div>
      <Input
        label={`${webformOrderID}`}
        hint={max200Characters}
        value={fieldData.webformOrderID}
        placeholder={placeHolderWebformOrderID}
        feedback={'webformOrderID' in formErrors ? 'error' : ''}
        error={
          'webformOrderID' in formErrors ? formErrors.webformOrderID.message : ''
        }
        onChange={({ target: { value } }) => {
        if (value.length > 200){
          setFormErrors({
            ...formErrors,
            webformOrderID: { message: 'Maximum 200 characters allowed' }
          });
        } else {
            const errors = { ...formErrors };
            delete errors.webformOrderID;
            setFormErrors({
              ...errors
            });
          }
          setFieldData(previousValue => ({
            ...previousValue,
            webformOrderID: value
          }));
        }}
      />
    </div>
  );
};

DefectWebformOrderId.propTypes = {
  formErrors: PropTypes.shape({
    webformOrderID: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    webformOrderID: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectWebformOrderId;
